import { render } from "./DialogAddLang.vue?vue&type=template&id=64eb9bd2"
import script from "./DialogAddLang.vue?vue&type=script&lang=js"
export * from "./DialogAddLang.vue?vue&type=script&lang=js"
script.render = render

export default script